export type ClassValue = string | false | null | undefined;

export const cx = (...classes: ClassValue[]) => classes.filter((value): value is string => Boolean(value)).join(' ');

